<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {ItemStateAction} from "@/modules/redactor/models/item/ItemStateAction";


export default {
  name: "r-item-state-action",
  props: {
    model: VueTypes.instanceOf(ItemStateAction),
    label: VueTypes.string.def("Action:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return ItemStateAction.getValues();
    }
  }
}

</script>
